// Minimal, opt-in perf logging for development.
// Enable by setting `window.__FG_PERF = true` in the console.

// Global toggles (can be set from console):
//   window.__FG_PERF = true|false    -> enable/disable logging (default: true)
//   window.__FG_PERF_THRESHOLD = n   -> min duration (ms) to log (default: 0 = log all)

export function perfEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  const flag = (window as any).__FG_PERF;
  return flag === true; // default off
}

function threshold(): number {
  if (typeof window === 'undefined') return 0;
  const t = (window as any).__FG_PERF_THRESHOLD;
  return typeof t === 'number' ? t : 0;
}

export function perf<T>(name: string, fn: () => T): T {
  if (!perfEnabled()) return fn();

  const start = performance.now();
  const result = fn();

  const log = () => {
    const duration = performance.now() - start;
    if (duration >= threshold()) {
      // eslint-disable-next-line no-console
      console.log(`[perf] ${name}: ${duration.toFixed(2)}ms`);
    }
  };

  if (result instanceof Promise) {
    // @ts-expect-error allow async logging
    return result.finally(log);
  }

  log();
  return result;
}

